"use client"
import { DndContext } from "@dnd-kit/core"

export function DndContextProvider(props: {
    children: React.ReactNode
}) {
    return (
        <DndContext>
            {props.children}
        </DndContext>
    )
}